import { useState } from 'react';

export const MN = ['Jan','Feb','Mrt','Apr','Mei','Jun','Jul','Aug','Sep','Okt','Nov','Dec'];
export const MD = [31,28,31,30,31,30,31,31,30,31,30,31];

export const C = {
  pri: '#0B1F4A', sec: '#00A3C4', acc: '#FFC233',
  bg1: '#FFFFFF', bg2: '#F5F8FB', bg3: '#EEF2F7',
  t1: '#0B1F4A', t2: '#3D4F6F', t3: '#8899AA',
  bdr: '#D9E2EC',
  grn: '#10B981', org: '#F59E0B', rd: '#EF4444',
  ch: ['#00A3C4','#0B1F4A','#FFC233','#10B981','#3D4F6F','#F59E0B','#0B1F4A','#06B6D4'],
  pg: {
    opwek: { bg: '#F5F8FB', bdr: '#D9E2EC', ico: '☀️', lbl: '#0B1F4A' },
    batt:  { bg: '#EFF6FF', bdr: '#BFDBFE', ico: '🔋', lbl: '#0B1F4A' },
    back:  { bg: '#F5F8FB', bdr: '#D9E2EC', ico: '🏭', lbl: '#3D4F6F' },
    grid:  { bg: '#F5F8FB', bdr: '#D9E2EC', ico: '⚡', lbl: '#3D4F6F' },
    vraag: { bg: '#EFF6FF', bdr: '#BFDBFE', ico: '🔌', lbl: '#0B1F4A' },
  }
} as const;

export function Tip({ text, children }: { text: string; children: React.ReactNode }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative inline-block" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      {children}
      {show && (
        <div className="absolute bottom-[calc(100%+6px)] left-1/2 -translate-x-1/2 bg-[#0B1F4A] text-white px-2.5 py-1.5 rounded-md text-[10px] leading-snug whitespace-nowrap z-[100] pointer-events-none shadow-lg">
          {text}
          <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[5px] border-t-[#0B1F4A]" />
        </div>
      )}
    </div>
  );
}
